"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DropdownMenu.default;
  }
});
var _DropdownMenu = _interopRequireDefault(require("./DropdownMenu"));